import { BreakpointNums } from 'components/style/Breakpoints.style';
import { createResponsiveStateReducer } from 'redux-responsive';

// Selectors
export const getSmallScreen = (state) => state.browser.lessThan.extraLarge;

// Reducer
export const browserReducer = createResponsiveStateReducer({
  extraSmall: null,
  small: BreakpointNums.sm,
  medium: BreakpointNums.md,
  large: BreakpointNums.lg,
  extraLarge: BreakpointNums.xl
});

export default browserReducer;



// WEBPACK FOOTER //
// ./src/actions/ui/browser.js